import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg, useApi, fmtDate } from "../../lib/api";

export const Referrals = () => {
  const { data, reload } = useApi("/referrals");
  const { data: jobs } = useApi("/public/jobs");
  const [f, setF] = useState({ candidate_name: "", candidate_email: "", job_id: "", note: "" });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/referrals", { ...f, job_id: f.job_id || null });
      toast.success("Referral logged. Ask your candidate to apply with this same email.");
      setF({ candidate_name: "", candidate_email: "", job_id: "", note: "" });
      reload();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <div className="grid lg:grid-cols-3 gap-6" data-testid="referrals">
      <form onSubmit={submit} className="panel p-5 grid gap-3 h-fit" data-testid="referral-form">
        <div className="eyebrow">Refer a candidate</div>
        <input required className="field" placeholder="Candidate name" value={f.candidate_name} onChange={set("candidate_name")} data-testid="referral-name-input" />
        <input required type="email" className="field" placeholder="Candidate email" value={f.candidate_email} onChange={set("candidate_email")} data-testid="referral-email-input" />
        <select className="field" value={f.job_id} onChange={set("job_id")} data-testid="referral-job-select">
          <option value="">General talent pool</option>
          {(jobs || []).filter((j) => !j.source_url).map((j) => <option key={j.id} value={j.id}>{j.title} — {j.brand}</option>)}
        </select>
        <textarea rows={2} className="field" placeholder="Why are they great?" value={f.note} onChange={set("note")} data-testid="referral-note-input" />
        <button className="btn-gold" data-testid="referral-submit-btn">Submit referral</button>
        <p className="text-[11px] text-slate-500">Bonus eligibility is flagged automatically when your candidate is hired. Bonus amounts: set by HR policy.</p>
      </form>
      <div className="lg:col-span-2 panel p-5">
        <div className="eyebrow mb-4">Referral tracker</div>
        <div className="divide-y divide-[color:var(--line)]">
          {(data || []).map((r) => (
            <div key={r.id} className="py-3 flex flex-wrap justify-between gap-2" data-testid={`referral-row-${r.id}`}>
              <div>
                <div className="text-sm text-ink">{r.candidate_name} <span className="text-slate-500">→ {r.job_title}</span></div>
                <div className="font-data text-[10px] text-slate-500">by {r.referrer_name} · {fmtDate(r.created_at)}</div>
              </div>
              <div className="flex gap-2">
                <span className="pill pill-slate">{r.application_status ? r.application_status.replace("_", " ") : "not applied yet"}</span>
                {r.bonus_eligible && <span className="pill pill-green" data-testid="referral-bonus-eligible">Bonus eligible</span>}
              </div>
            </div>
          ))}
          {data?.length === 0 && <div className="text-sm text-slate-500 py-4">No referrals yet.</div>}
        </div>
      </div>
    </div>
  );
};
